<div>
  <div class="row">
    <app-dql-search-field-simple class="col" [expression]="fromCriteria" [disableDelete]="true" #from></app-dql-search-field-simple>
    <app-dql-search-field-simple class="col" [expression]="toCriteria" [disableDelete]="true" #to></app-dql-search-field-simple>
    <i class="icomoon icomoon-exit" *ngIf="!disableDelete" (click)="onDelete.emit(expression)"></i>
  </div>
</div>
